/**
* 基础菜单 商品上架管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.saleName" placeholder="输入销售名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.productCode" placeholder="输入商品编码" clearable></el-input>
      </el-form-item>
      <!--      <el-form-item label="">-->
      <!--        <el-input size="small" v-model="formInline.brandName" placeholder="输入商品品牌" clearable></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item label="">
        <el-select v-model="formInline.putaway" placeholder="请选择上下架状态" clearable>
          <el-option label="已上架" value="75"></el-option>
          <el-option label="已下架" value="76"></el-option>
          <el-option label="未上架" value="77"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.saleNum" placeholder="销量排序" clearable>
          <el-option label="销量升序" value="1"></el-option>
          <el-option label="销量降序" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="warning" @click="exportExcel">导出</el-button>
        <el-button size="small" type="warning" @click="setLabelLabel">设置标签</el-button>
        <el-button size="small" type="danger" @click="steDeleteLabel">删除标签</el-button>
        <!-- <el-button size="small" type="warning" plain @click="batch">批量导入上架信息</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 630px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          fixed
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="product_code" fixed label="商品编码" width="160" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_name" fixed label="商品名称" min-width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="sale_name" fixed label="销售名称" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="erp_stock_num" fixed label="erp库存数量" width="120" :show-overflow-tooltip='true'
                         v-if="authprice">
        </el-table-column>
        <el-table-column prop="erp_price" fixed label="erp商品基价" width="120" :show-overflow-tooltip='true'
                         v-if="authstocknum">
          <template slot-scope="scope">
            <div v-if="scope.row.erp_price||scope.row.erp_price==0">￥{{scope.row.erp_price}}</div>
          </template>
        </el-table-column>
<!--        <el-table-column prop="operation_type" fixed label="类型" width="100">-->
<!--          <template slot-scope="scope">-->
<!--            <div plain v-if="scope.row.operation_type=='2910'">自营</div>-->
<!--            <div plain v-else-if="scope.row.operation_type=='2911'">代发</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="sale_price" fixed label="销售单价" width="125">
          <template slot-scope="scope" style="position: relative">
            <div v-if="scope.row.putaway_status!='75'"><span v-if="scope.row.sale_price">￥</span>{{scope.row.sale_price}}
            </div>
            <div v-else>
              <span class="price_icon">￥</span>
              <el-input v-model="scope.row.sale_price" placeholder="销售单价" maxLength="10" clearable
                        @input="handlerPriceChange(scope.row.sale_price)"
                        @blur="revisePrice(scope.row.id,scope.row.sale_price)"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="putaway_num" fixed label="上架数量" width="125" maxLength="10">
          <template slot-scope="scope">
            <!-- <div v-if="scope.row.putaway_status!='75'">{{scope.row.putaway_num}}</div>
            <div v-else>
              <el-input v-model="scope.row.putaway_num" placeholder="上架数量" maxLength="6" clearable
                        @input="handlerNumChange(scope.row.putaway_num)"
                        @blur="reviseNum(scope.row.id,scope.row.putaway_num)"></el-input>
            </div> -->
            <div>{{scope.row.putaway_num}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="lock_num" label="锁定库存数" width="90">
        </el-table-column>
        <el-table-column prop="sale_num" label="已售数量" width="80">
        </el-table-column>
        <el-table-column prop="putaway_status" label="状态" width="100">
          <template slot-scope="scope">
            <div plain style="color: #F56C6C" v-if="scope.row.putaway_status=='76'">已下架</div>
            <div plain v-else-if="scope.row.putaway_status=='77'">未上架</div>
            <div plain style="color: #409eff" v-else>已上架</div>
          </template>
        </el-table-column>
        <el-table-column prop="label_name" label="标签名称" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="putaway_time" label="上架时间" width="150">
          <template slot-scope="scope">
            <div>{{scope.row.putaway_time|timestampToTime}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="lowest_sale_num" label="起购数量" width="150">
        </el-table-column>
        <el-table-column prop="limit_num" label="限购数量" width="150">
        </el-table-column>
        <el-table-column prop="sb_group_price" label="集团价" width="100" v-if="songbai_system==1">
          <template slot-scope="scope">
            <div v-if="scope.row.sb_group_price>0">￥{{scope.row.sb_group_price}}</div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column prop="off_shelf_reason" label="下架原因" width="135" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column align="center" label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="undercarriage(scope.row.product_id)"
                       style="width: 80px;color: #F56C6C;background-color: #fff;"
                       v-if="scope.row.putaway_status=='75'">下架
            </el-button>
            <el-button type="danger" size="mini" @click="groundEdit(scope.row.product_id,scope.row.product_name,scope.row.id)"
                       style="width: 80px;color: #F56C6C;background-color: #fff;"
                       v-if="scope.row.putaway_status=='75'">修改
            </el-button>
            <!-- <el-button type="primary" size="mini" style="width: 80px;"
                       @click="grounding(scope.row.product_id,scope.row.product_name,scope.row.id)" v-else>
              上架
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="设置标签"
               :visible.sync="labelDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form :model="labelForm" :rules="labelRules" ref="labelForm" label-width="125px" class="sortForm">
        <el-form-item label="标签名称" prop="labelId" class="giftForm">
          <el-select v-model="labelForm.labelId" filterable placeholder="请选择标签名称" clearable
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusLabelName()" @change="changeLabelName()" @clear="clear()">
            <el-option
              v-for="item in labelData"
              :key="item.id"
              :label="item.label_name"
              :value="item.id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="labelHandleSizeChange"
                             @current-change="labelHandleCurrentChange"
                             :current-page.sync="labelCurrentPage"
                             :page-size="labelPagesize"
                             layout="total, prev, pager, next"
                             :total="labelTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="labelDialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="sureLabel('labelForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="groundingDialogVisible"
               width="45%"
               center>
      <el-form label-width="150px" :model="groundingForm" :rules="rules" ref="grounding" class="groundingForm">
        <el-form-item label="商品名称" prop="product_name">
          <div>{{product_name}}</div>
        </el-form-item>
<!--        <el-form-item label="商品类型" prop="operation_type">-->
<!--          <el-select v-model="groundingForm.operation_type" placeholder="请选择商品类型" clearable @change="changeSendMode">-->
<!--            <el-option label="自营" value="2910"></el-option>-->
<!--            <el-option label="代发" value="2911"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="供应商名称" prop="seller_supplier_product_id" v-if="groundingForm.operation_type=='2911'">-->
<!--          <el-select v-model="groundingForm.seller_supplier_product_id" placeholder="请选择供应商名称" clearable>-->
<!--            <el-option class="sellerList"-->
<!--                       v-for="item in sellerList"-->
<!--                       :key="item.seller_supplier_product_id"-->
<!--                       :label="item.seller_supplier_name"-->
<!--                       :value="item.seller_supplier_product_id">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="销售名称" prop="sale_name">
          <el-input size="small" v-model="groundingForm.sale_name" auto-complete="off" clearable
                    placeholder="请输入销售名称"></el-input>
          <div class="lineHeight20 f12 colorA8ABB2">品牌名称 产品名称 规格型号 +（可以加1-2个医生之间常用的商品昵称）</div>
        </el-form-item>
        <el-form-item label="销售单价" prop="sale_price">
          <el-input type="text" size="small" v-model="groundingForm.sale_price" auto-complete="off" maxlength="10"
                    clearable show-word-limit
                    placeholder="请输入销售单价"></el-input>
        </el-form-item>
        <el-form-item label="上架数量" prop="num">
          <el-input type="text" size="small" v-model="groundingForm.num" auto-complete="off" min="1" maxlength="10"
                    clearable show-word-limit
                    placeholder="请输入上架数量"></el-input>
        </el-form-item>
        <el-form-item label="起售数量" prop="lowest_sale_num">
          <el-input type="text" size="small" v-model="groundingForm.lowest_sale_num" auto-complete="off" min="1"
                    maxlength="4" clearable show-word-limit
                    placeholder="请输入起售数量"></el-input>
        </el-form-item>
        <el-form-item label="限购数量" prop="limit_num">
          <el-input type="text" size="small" v-model="groundingForm.limit_num" auto-complete="off" min="1" maxlength="4"
                    clearable show-word-limit
                    placeholder="请输入限购数量"></el-input>
          <span style="color: red">0为不限购</span>
        </el-form-item>
        <el-form-item label="是否可超库存购买" prop="buy_nostock">
          <el-select v-model="groundingForm.buy_nostock" placeholder="请选择是否可超库存购买" clearable>
            <el-option v-for="nostock in nostockList" :key="nostock.value" :label="nostock.name"
                       :value="nostock.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否议价" prop="is_nego">
          <el-select v-model="groundingForm.is_nego" placeholder="请选择是否议价" clearable>
            <el-option v-for="item in negoList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否搜索隐藏" prop="is_search_hide">
          <el-select v-model="groundingForm.is_search_hide" placeholder="请选择是否搜索隐藏" clearable>
            <el-option v-for="item in negoList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="列表图片" prop="list_pic_url" class="list_pic_url">
          <div style="position: absolute;left: -68px;top: 20px;color: red">(240*240)</div>
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-remove="handleRemove"
            :http-request="handleUpload"
            :before-upload="beforeUpload"
          >
            <img v-if="form.image" :src="form.image" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div style="margin-left: 150px;margin-bottom: 20px;width: 500px" v-if="product_big_pics.length">
          <div v-if="product_big_pics.length<5">
            <div style="width: 120px;display: inline-block;margin-right: 5px" v-for="(item,index) in product_big_pics"
                 :key="index"><img class="productImg" :src="item" alt="" @click="clickImg(item)"></div>
          </div>
          <div v-else>
            <template>
              <div>
                <swiper :options="swiperOption" ref="mySwiper" class="swiper">
                  <swiper-slide style="width: 120px" v-for="(item,index) in product_big_pics" :key="index"><img
                    class="productImg" :src="item" alt="" @click="clickImg(item)"></swiper-slide>
                  <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
              </div>
            </template>
          </div>
        </div>
        <el-form-item label="商品关键词" prop="keywords">
          <el-input type="textarea" size="small" v-model="groundingForm.keywords" auto-complete="off" clearable
                    class="keywordTextarea"
                    placeholder="请输入商品关键词,多个关键字之间用','分隔"></el-input>
        </el-form-item>
        <el-form-item label="商品计量单位" prop="unit_id" v-if="company_type != 2822">
          <el-select v-model="groundingForm.unit_id" placeholder="请选择商品计量单位" clearable>
            <el-option v-for="number in numberList" :key="number.unit_id" :label="number.unit_name"
                       :value="number.unit_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指定查询城市" prop="zd_province">
          <el-select
            v-model="groundingForm.zd_province"
            multiple clearable
            placeholder="请选择"
            @change="handzdprovince"
            :disabled="iszdprovince">
            <el-option
              v-for="item in provinceList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="限制查询城市" prop="xz_province">
          <el-select
            v-model="groundingForm.xz_province"
            multiple clearable
            placeholder="请选择"
            @change="handxzprovince"
            :disabled="isxzprovince">
            <el-option
              v-for="item in provinceList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="集团价" prop="sb_group_price" v-if="songbai_system==1">
          <el-input type="text" size="small" v-model="groundingForm.sb_group_price" auto-complete="off" maxlength="10"
                    clearable show-word-limit
                    placeholder="请输入集团价"></el-input>
        </el-form-item>
        <el-form-item label="订单不可取消期限" prop="refuse_return_days">
          <el-input type="text" size="small" v-model="groundingForm.refuse_return_days" auto-complete="off" clearable
                    show-word-limit
                    placeholder="请输入订单不可取消期限"></el-input>
          <span>天</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="groundingDialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="sureGrounding('grounding')" :disabled="!isCanSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="下架原因"
               :visible.sync="undercarriageDialogVisible"
               width="30%"
               center>
      <el-input type="textarea" v-model="undercarriageReason" class="textarea" placeholder="请输入下架原因" maxLength="50"
                clearable
                :rows="6"></el-input>
      <span slot="footer" class="dialog-footer">
            <el-button @click="undercarriageDialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="sureUndercarriage()">确 定</el-button>
      </span>
    </el-dialog>

<!--    批量导入上架信息-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="批量导入上架信息" :before-close="importHandleClose"
               :visible.sync="importDialogVisible"
               width="40%"
               top="6vh"
               center>
<!--      上传excel文件-->
      <div class="zipFile">
        <div style="width: 200px;height: 150px">
          <el-upload :http-request="uploadFile"
                     ref="excelLoad"
                     action="#"
                     :before-upload="excelBeforeUpload"
                     :limit="1"
                     :auto-upload="true">
            <div class="icon-container">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </div>
        <div class="prompt">请在下载的模板中填入基础信息后在此处上传</div>
      </div>
      <div style="text-align: center;margin: 10px 0;">
        <el-button size="small" type="primary" :loading="loading" @click="confirmImport" :disabled="!isCanSubmit">确认导入</el-button>
        <el-button size="small" :loading="loading" @click="download">下载模版</el-button>
      </div>
      <!--列表-->
      <div class="importLog">导入日志</div>
      <div style="height: 300px;overflow-y: auto">
        <el-table size="small" :data="importlistData" highlight-current-row v-loading="loading" border
                  @cell-dblclick="cellDbClick"
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column
            type="index"
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{importpageparm.pageSize * (importpageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="导入时间" width="150" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div>{{scope.row.create_time|timestampToTime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="file_name" label="文件名称" min-width="150" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="status" label="导入结果" width="120" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div plain v-if="scope.row.status=='0'">处理中</div>
              <div plain v-else-if="scope.row.status=='1'">处理成功</div>
              <div plain v-else>处理失败</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini"
                         @click="results(scope.row.file_id, scope.row.error_message, scope.row.status, scope.row.total_fail, scope.row.total_success, scope.row.total_fail)"
                         v-if="scope.row.status != '0'"
                         style="width: 80px">查看结果
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="importpageparm" @callFather="importFather"></Pagination>
    </el-dialog>

    <!--导入结果-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="导入结果"
               :visible.sync="resultsDialogVisible"
               width="40%"
               top="15vh"
               center>
      <!--列表-->
      <div v-if="importWas">
        <div class="importtion">
          已成功导入<span class="color409EFF">{{ total_success }}</span>条数据，<span class="colorec808d">{{ total_fail }}</span>条数据导入失败
        </div>
        <div style="height: 300px;overflow-y: auto">
          <el-table size="small" :data="resultslistData" highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick"
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column
              label="序号"
              width="60">
              <template slot-scope="scope">
                {{resultsPageparm.pageSize * (resultsPageparm.currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="product_code" label="商品编码" min-width="150" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="product_name" label="商品名称" width="200" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="error_message" label="失败原因" width="200" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <span class="colord9001b">{{ scope.row.error_message }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="resultsPageparm" @callFather="resultscallFather"></Pagination>
        <div slot="footer" class="dialog-footer textCenter">
          <el-button type="primary" @click="resultsDialogVisible = false">确 认</el-button>
        </div>
      </div>
      <div class="textCenter" v-if="totalFail">
        <div class="resultent">已成功导入{{ total_success }}条数据，{{ total_fail }}条数据导入失败</div>
        <div style="margin-top: 20px">
          <el-button type="primary" @click.capture="resultsDialogVisible = false">确 认</el-button>
        </div>
      </div>
      <div class="textCenter" v-if="importFailed">
        <div class="resultent">{{ this.errorMessage }}</div>
        <div style="margin-top: 20px">
          <el-button type="primary" @click.capture="resultsDialogVisible = false">确 认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  productList,
  productPutaway,
  productExcel,
  productRevisePrice,
  productReviseNum,
  sellerProductDetail,
  labelList,
  setLabel,
  deleteLabel,
  productBigPic,
  unitList,
  getSellerInfo,
  productSupplierList,
  importLogsList,
  putawayExport,
  importLogsDetailList,
  putawayBatchImport
} from '../../api/basisMG'
  import {locationArea, upload, getToken, thumbListPic} from '../../api/commonMG'
  import Pagination from '../../components/Pagination'
  import {uploadFile} from '../../utils/util'
  import {swiper, swiperSlide} from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import {param} from '../../api/commonMG'
  import axios from "axios";

  export default {
    name: 'goods',
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入上架数量'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      var validateLowestsalenum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入起售数量'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      var validateLimitnum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入限购数量'));
        } else if (!(/(^[0-9]\d*$)/.test(value))) {
          return callback(new Error('请输入整数'));
        } else {
          return callback();
        }
      };
      var validateSalePrice = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入销售单价'));
        } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value))) {
          return callback(new Error('输入长度过长或格式不正确'));
        } else {
          return callback();
        }
      };
      var validatesbGroupPrice = (rule, value, callback) => {
        if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value)) && value != '' && value != undefined) {
          return callback(new Error('输入长度过长或格式不正确'));
        } else {
          return callback();
        }
      };
      var validateDay = (rule, value, callback) => {
        console.log(value)
        if (!(/(^[1-9]\d*$)/.test(value)) && value != '' && value != undefined) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        swiperOption: {
          loop: false,
          slidesPerView: 4,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        props: {multiple: true},
        loading: false, //是显示加载
        groundingDialogVisible: false,//上架弹窗
        undercarriageDialogVisible: false,//下架弹窗
        labelDialogVisible: false,//标签弹窗
        importDialogVisible: false,
        undercarriageReason: '',//下架原因
        dialogTitle: '',
        isRewiriteEditor: false,
        formInline: {
          page: 1,
          rows: 10,
          saleName: '',
          productCode: '',
          putaway: '',
          brandName: '',
          saleNum: ''
        },
        groundingForm: {
          sale_name: '',
          sale_price: '',
          num: '',
          list_pic: '',
          list_pic_url: '',
          keywords: '',
          limit_num: '0',
          lowest_sale_num: '1',
          buy_nostock: 0,
          is_nego: 0,
          is_search_hide: 0,
          zd_province: [],
          xz_province: [],
          sb_group_price: '',
          refuse_return_days: '',
          product_pic_url:'',
          unit_number: '',
          unit_id: '',
          // operation_type:'',
          // seller_supplier_id:'',
          // seller_supplier_product_id:''
        },
        sellerId: '',
        labelForm: {
          labelId: '',
          saleIds: []
        },
        // listForm: {
        //   zip_url: ''
        // },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        // rules表单验证
        rules: {
          sale_name: [
            {required: true, message: '请输入销售名称', trigger: 'blur'}
          ],
          sale_price: [{required: true, validator: validateSalePrice, trigger: 'blur'}],
          num: [{required: true, validator: validateNum, trigger: 'blur'}],
          // list_pic_url: [{required: true, message: '请选择上传图片', trigger: 'change'}],
          keywords: [{required: true, message: '请输入商品关键词', trigger: 'blur'}],
          lowest_sale_num: [{required: true, validator: validateLowestsalenum, trigger: 'blur'}],
          limit_num: [{required: true, validator: validateLimitnum, trigger: 'blur'}],
          buy_nostock: [{required: true, message: '请选择是否可超库存购买', trigger: 'change'}],
          sb_group_price: [{required: false, validator: validatesbGroupPrice, trigger: 'blur'}],
          refuse_return_days: [{required: false, validator: validateDay, trigger: 'blur'}],
          // unit_id: [{required: true, message: '请选择商品计量单位', trigger: 'blur'}],
          is_nego: [{required: true, message: '请选择是否议价', trigger: 'blur'}],
          // operation_type:[{required: true, message: '请选择商品类型', trigger: 'blur'}],
          // seller_supplier_product_id:[{required: true, message: '请选择供货商名称', trigger: 'blur'}]
        },
        labelRules: {
          labelId: [{required: true, message: '请选择标签名称', trigger: 'blur'}]
        },
        dialogImageUrl: '',
        dialogVisible: false,
        imgUrl: '',
        product_id: '',
        product_name: '',
        selectTableData: [],
        productId: '',
        form: {
          image: ''
        },
        isCanSubmit: true,
        nostockList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        negoList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        labelData: [],
        labelName: '',
        labelCurrentPage: 1,
        labelPagesize: 10,
        labelTotalSize: 0,
        small: true,
        selectedLabelName: '',
        zdgroundingOptions: [],
        xzgroundingOptions: [],
        provinceList: [],
        saleIds: '',
        seller_id: '',
        songbai_system: localStorage.getItem('songbai_system'),
        gridData: {},
        authprice: false,
        authstocknum: false,
        product_big_pics: [],
        numberList: [],
        company_type: '',
        sellerList: [],
        importlistData: [],
        importpageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        listFormInline: {
          page: 1,
          rows: 10,
          fileId: ''
        },
        summaryFormInline: {
          page: 1,
          rows: 10,
          fileId: ""
        },
        resultsDialogVisible: false,
        resultsPageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        importFailed: false,
        importWas: false,
        totalFail: false,
        total_success: '',
        total_fail: '',
        resultslistData: [],
        excelFileData: ''
      }
    },
    // 注册组件
    components: {
      Pagination,
      swiper,
      swiperSlide
    },
    /**
     * 创建完毕
     */
    created() {
      if (this.$route.query.putaway_status) {
        this.formInline.putaway = this.$route.query.putaway_status
        this.getdata(this.formInline)
      } else {
        this.getdata(this.formInline)
      }
    },
    computed: {
      iszdprovince() {
        return this.groundingForm.xz_province.length > 0;
      },
      isxzprovince() {
        return this.groundingForm.zd_province.length > 0;
      },
    },
    mounted() {
      this.getSellerInfos()
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      handzdprovince(value) {
        if (value.length === 0) {
          this.groundingForm.xz_province;
        } else {
          // 否则禁用限制查询城市
          this.groundingForm.xz_province = [];
        }
      },
      handxzprovince(value) {
        if (value.length === 0) {
          this.groundingForm.zd_province;
        } else {
          // 否则禁用指定查询城市
          this.groundingForm.zd_province = [];
        }
      },
      //获取公司类型
      getSellerInfos() {
        getSellerInfo()
          .then(res => {
            if (res.success) {
              this.company_type = res.content.seller_type;
            }
          })
          .catch(err => {
          })
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        productList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content.authInfoRes) {
                if (res.content.authInfoRes.auth_price == false || res.content.authInfoRes.auth_stock_num == false) {
                  this.authprice = false
                  this.authstocknum = false
                } else {
                  this.authprice = true
                  this.authstocknum = true
                }
              }
              this.listData = res.content.gridData.content
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.gridData.totalSize
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      //下架
      undercarriage(product_id) {
        this.product_id = product_id;
        this.undercarriageReason = '';
        this.undercarriageDialogVisible = true;
      },
      // 下架原因-确定
      sureUndercarriage() {
        this.undercarriageDialogVisible = false;
        let parameter = {
          product_id: this.product_id,
          putaway_status: 76,
          off_shelf_reason: this.undercarriageReason
        }
        productPutaway(parameter)
          .then(res => {
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '下架成功!'
              });
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 上架修改-弹窗
      groundEdit(product_id, product_name, id) {
        this.product_id = product_id;
        this.product_name = product_name;
        this.groundingDialogVisible = true;
        this.dialogTitle = '上架修改';
        this.getProductBigPic(product_id)
        this.getUnitList(product_id)
        this.getLocationArea()
        // this.getSellerPurchaserName(product_id)
        this.groundingForm = {
          sale_name: '',
          sale_price: '',
          num: '',
          list_pic: '',
          list_pic_url: '',
          keywords: '',
          limit_num: '0',
          lowest_sale_num: '1',
          buy_nostock: 0,
          is_nego: 0,
          is_search_hide: '',
          zd_province: [],
          xz_province: [],
          sb_group_price: '',
          refuse_return_days: '',
          product_pic_url:'',
          unit_number: '',
          unit_id: '',
          // operation_type:'',
          // seller_supplier_id:'',
          // seller_supplier_product_id:''
        };
        this.form.image = '';
        this.imgUrl = '';
        if (id) {
          sellerProductDetail(id)
            .then(res => {
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                let data = res.content;
                this.groundingForm = {
                  sale_name: data.sale_name,
                  sale_price: data.sale_price,
                  num: data.putaway_num,
                  list_pic: data.list_pic,
                  list_pic_url: data.list_pic_url,
                  keywords: data.keywords,
                  limit_num: data.limit_num || '0',
                  lowest_sale_num: data.lowest_sale_num || '1',
                  buy_nostock: data.buy_nostock || 0,
                  is_nego: data.is_nego || 0,
                  is_search_hide: data.is_search_hide,
                  zd_province: data.zd_province || [],
                  xz_province: data.xz_province || [],
                  sb_group_price: data.sb_group_price,
                  product_pic_url:data.product_pic_url,
                  refuse_return_days: data.refuse_return_days,
                  unit_id: data.unit_id,
                  // operation_type:data.operation_type.toString(),
                  // seller_supplier_id:data.seller_supplier_id,
                  // seller_supplier_product_id:data.seller_supplier_product_id
                }
                this.imgUrl = data.list_pic_url
                this.form.image = data.list_pic_url
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      //上架-弹窗
      grounding(product_id, product_name, id) {
        this.product_id = product_id;
        this.product_name = product_name;
        this.groundingDialogVisible = true;
        this.dialogTitle = '商品上架';
        this.getProductBigPic(product_id)
        this.getUnitList(product_id)
        this.getLocationArea()
        // this.getSellerPurchaserName(product_id)
        this.groundingForm = {
          sale_name: '',
          sale_price: '',
          num: '',
          list_pic: '',
          list_pic_url: '',
          keywords: '',
          limit_num: '0',
          lowest_sale_num: '1',
          buy_nostock: 0,
          is_nego: 0,
          is_search_hide: '',
          zd_province: [],
          xz_province: [],
          sb_group_price: '',
          refuse_return_days: '',
          product_pic_url:'',
          unit_number: '',
          unit_id: '',
          // operation_type:'',
          // seller_supplier_id:'',
          // seller_supplier_product_id:''
        };
        this.form.image = '';
        this.imgUrl = '';
        if (id) {
          sellerProductDetail(id)
            .then(res => {
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                let data = res.content;
                this.groundingForm = {
                  sale_name: data.sale_name,
                  sale_price: data.sale_price,
                  num: data.putaway_num,
                  list_pic: data.list_pic,
                  list_pic_url: data.list_pic_url,
                  keywords: data.keywords,
                  limit_num: data.limit_num || '0',
                  lowest_sale_num: data.lowest_sale_num || '1',
                  buy_nostock: data.buy_nostock || 0,
                  is_nego: data.is_nego || 0,
                  is_search_hide: data.is_search_hide,
                  zd_province: data.zd_province || [],
                  xz_province: data.xz_province || [],
                  sb_group_price: data.sb_group_price,
                  product_pic_url:data.product_pic_url,
                  refuse_return_days: data.refuse_return_days,
                  unit_id: data.unit_id,
                  // operation_type:data.operation_type.toString(),
                  // seller_supplier_id:data.seller_supplier_id,
                  // seller_supplier_product_id:data.seller_supplier_product_id
                }
                this.imgUrl = data.list_pic_url
                this.form.image = data.list_pic_url
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      getUnitList(product_id) {
        unitList(product_id)
          .then(res => {
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.numberList = res.content;
              this.groundingForm.unit_id = res.content[0].unit_id;
            }
        })
        .catch(err => {
          // this.$message.error('网络错误，请稍后再试！')
        })
      },
      getProductBigPic(product_id) {
        this.product_big_pics = [];
        productBigPic(product_id).then(res => {
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.product_big_pics = res.content;
          }
        }).catch(err => {
          this.$message.error('网络错误，请稍后再试！')
        })
      },
      getLocationArea(code, type) {
        let pid = code || ''
        locationArea(pid).then(res => {
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.provinceList = res.content
          }
        }).catch(err => {
          this.$message.error('网络错误，请稍后再试！')
        })
      },
      getSellerPurchaserName(product_id) {
        let body = {
          product_id:product_id
        }
        productSupplierList(body)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.sellerList = res.content;
              // this.sellerList.forEach((item)=>{
              //   if(item.seller_supplier_id == this.groundingForm.seller_supplier_id) {
              //     this.sellerId = item.seller_supplier_product_id
              //   }
              // })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      changeSendMode() {
        this.groundingForm = {
          sale_name: this.groundingForm.sale_name,
          sale_price: this.groundingForm.sale_price,
          num: this.groundingForm.num,
          list_pic: this.groundingForm.list_pic,
          list_pic_url: this.groundingForm.list_pic_url,
          keywords: this.groundingForm.keywords,
          limit_num: this.groundingForm.limit_num || '0',
          lowest_sale_num: this.groundingForm.lowest_sale_num || '1',
          buy_nostock: this.groundingForm.buy_nostock || 0,
          is_nego: this.groundingForm.is_nego || 0,
          zd_province: this.groundingForm.zd_province || [],
          xz_province: this.groundingForm.xz_province || [],
          sb_group_price: this.groundingForm.sb_group_price,
          product_pic_url:this.groundingForm.product_pic_url,
          refuse_return_days: this.groundingForm.refuse_return_days,
          unit_id: this.groundingForm.unit_id,
          // operation_type:this.groundingForm.operation_type,
          // seller_supplier_id: '',
          // seller_supplier_product_id: ''
        }
      },
      //确认上架
      sureGrounding(formName) {
        this.groundingForm.list_pic_url = this.imgUrl;
        this.groundingForm.putaway_status = 75;
        this.groundingForm.product_id = this.product_id;
        this.groundingForm.unit_number = this.unit_id;
        // this.groundingForm.seller_supplier_product_id = this.seller_supplier_product_id;
        if (this.groundingForm.num) {
          this.groundingForm.num = Number(this.groundingForm.num);
        }
        if (this.groundingForm.sale_price) {
          this.groundingForm.sale_price = Number(this.groundingForm.sale_price);
        }
        if (this.groundingForm.sb_group_price) {
          this.groundingForm.sb_group_price = Number(this.groundingForm.sb_group_price);
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            productPutaway(this.groundingForm)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false
                if (res.code == -3) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '上架成功!'
                    });
                    this.groundingDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
          }
        });
      },
      handleRemove(file) {
        console.log(file);
      },
      // 列表图片-限制图片尺寸
      limitFileWH(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          //upload为上传的接口
          // upload(fileData).then(res => {
          //   this.imgUrl = res.attrs.file_url;
          //   //对返回的图片地址进行回显
          //   this.$set(this.form, "image", res.attrs.file_url);
          // });
          //先根据后台获取token
          getToken().then(res => {
            if (res) {
              let result = uploadFile(res, file);
              result.then(res => {
                console.log(res)
                this.imgUrl = res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.form, "image", res.data.content.file.fileUrl);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      // 列表图片
      beforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png";
        const isLt2M = file.size / 1024 / 1024 < 2;
        // if (!isJPG) {
        //   this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
        //   return;
        // }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!");
          return;
        }
        // 调用[限制图片尺寸]函数
        this.limitFileWH(240, 240, file)
      },
      //导出
      exportExcel() {
        productExcel(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', '商品信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      //修改单价
      revisePrice(id, price) {
        if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(price))) {
          this.$message.error('输入长度过长或格式不正确');
          return
        }
        if (this.isRewiriteEditor) {
          this.$confirm('确定修改商品单价?', '确认修改', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let parameter = {
              sellerProductId: id,
              price: price
            }
            productRevisePrice(parameter)
              .then(res => {
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '修改成功!'
                  });
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }
      },
      //修改数量
      reviseNum(id, num) {
        if (!(/(^[1-9]\d*$)/.test(num))) {
          this.$message.error('请输入正确的上架数量!');
          return
        }
        if (this.isRewiriteEditor) {
          this.$confirm('确定修改商品上数量?', '确认修改', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let parameter = {
              sellerProductId: id,
              num: num
            }
            productReviseNum(parameter)
              .then(res => {
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '修改成功!'
                  });
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }
      },
      handlerPriceChange(price) {
        this.isRewiriteEditor = true;
      },
      handlerNumChange(num) {
        this.isRewiriteEditor = true;
      },
      // 可以获取图片参数
      handleUpload(file) {
        console.log(file)
      },
      // 关闭设置标签弹窗
      handleClose() {
        this.$refs["labelForm"].resetFields();
        this.labelDialogVisible = false;
      },
      // 设置标签按钮
      setLabelLabel() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        this.labelForm.saleIds = [];
        this.labelForm = {};
        this.labelDialogVisible = true;
        this.saleIds = this.selectTableData[0].saleIds;
        this.getLabel();
      },
      getLabel(labelName) {
        let param = {
          page: this.labelCurrentPage,
          rows: 10,
          label_name: labelName,

        }
        labelList(param)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.content.rows.length) {
                this.selectedLabelName = ''
              }
              this.labelData = res.content.rows;
              this.labelTotalSize = res.content.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 设置标签-确定
      sureLabel() {
        this.labelForm.saleIds = [];
        this.selectTableData.forEach((item) => {
          this.labelForm.saleIds.push(item.sale_id)
        })
        this.loading = true;
        setLabel(this.labelForm)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功设置标签!'
              })
              this.labelDialogVisible = false;
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.isCanSubmit = true;
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 删除标签
      steDeleteLabel() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        this.labelForm.saleIds = []
        this.selectTableData.forEach((item) => {
          this.labelForm.saleIds.push(item.sale_id)
        })
        const title = '是否删除商品销售标签？';
        this.$confirm(title, '删除销售标签', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          let obj = {
            saleIds: this.labelForm.saleIds
          }
          deleteLabel(obj)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      focusLabelName() {
        if (!this.selectedLabelName) {
          this.labelName = ''
          this.getLabel('')
        }
      },
      remoteMethod(val) {
        this.labelCurrentPage = 1
        this.labelName = val;
        this.getLabel(val)
      },
      changeLabelName() {
        this.labelCurrentPage = 1
        this.labelData.forEach((item) => {
          if (item.id == this.labelForm.id) {
            this.selectedLabelName = item.label_name;
            this.getLabel(item.label_name)
          }
        })
      },
      clear() {
        this.getLabel()
        this.labelCurrentPage = 1
        this.labelName = ''
      },
      labelHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.labelPagesize = val;
        this.getLabel(this.labelName)
      },
      labelHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.labelCurrentPage = val;
        this.getLabel(this.labelName)
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      clickImg(item) {
        this.groundingForm.product_pic_url = item;
        this.imgUrl = item;
        this.$set(this.form, "image", item);
        // thumbListPic(item).then(res => {
        //   this.loading = false
        //   if (res.success == false) {
        //     this.$message({
        //       type: 'info',
        //       message: res.msg
        //     })
        //   } else {
        //     this.imgUrl = res.content;
        //     this.groundingForm.product_pic_url = this.imgUrl
        //     //对返回的图片地址进行回显
        //     this.$set(this.form, "image", res.content);
        //   }
        // })
        //   .catch(err => {
        //     this.loading = false
        //     this.$message.error('网络错误，请稍后再试！')
        //   })
      },
      // 批量导入上架信息弹窗
      batch() {
        this.importDialogVisible = true;
        this.getImport(this.listFormInline)
      },
      // 获取导入日志列表
      getImport(parameter) {
        this.loading = true
        importLogsList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.importlistData = res.content.rows
              // 分页赋值
              this.importpageparm.currentPage = this.listFormInline.page
              this.importpageparm.pageSize = this.listFormInline.rows
              this.importpageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      importFather(parm) {
        this.listFormInline.page = parm.currentPage
        this.listFormInline.rows = parm.pageSize
        this.getImport(this.listFormInline)
      },
      // 关闭批量导入上架信息弹窗
      importHandleClose(done) {
        this.$refs.excelLoad.clearFiles();
        this.importDialogVisible = false;
        done()
      },
      // 上传excel文件
      excelBeforeUpload(file) {
        const isExcel = file.type === 'application/vnd.ms-excel' || file.name.endsWith('.xls') || file.name.endsWith('.xlsx');
        // const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isExcel) {
          this.$message({
            message: "请上传excel文件!",
            type: "error",
          });
          return false;
        }
        // if (!isLt10M) {
        //   this.$message.error('上传excel大小不能超过10MB哦!');
        //   return false;
        // }
        const fileData = new FormData();
        fileData.append("file", file);
        this.excelFileData = fileData
      },
      // 确认导入
      confirmImport() {
        if (!this.$refs.excelLoad.uploadFiles || this.$refs.excelLoad.uploadFiles.length === 0) {
          this.$message.error('请上传xlsx文件');
          return;
        }
        this.isCanSubmit = false
        this.loading = true
        putawayBatchImport(this.excelFileData)
          .then(res => {
            this.isCanSubmit = true
            this.loading = false
            if (res.code == -3) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else if (res.code == 0) {
                this.$message({
                  type: 'info',
                  message: '数据正在进行导入，请稍后查看结果！'
                })
                this.getImport(this.listFormInline)
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功导入上架信息'
                });
                this.importHandleClose();
                this.getdata(this.formInline)
              }
            }
          })
          .catch(err => {
            this.isCanSubmit = true
            this.loading = false
            // this.$message.error('网络错误,请稍后再试!')
          })
      },
      // 下载模版
      download(params) {
        this.loading = true;
        putawayExport(params)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', 'notSaleTemp.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 查看结果
      results(file_id, error_message, status, total_fail, total_success) {
        this.summaryFormInline.fileId = file_id;
        this.total_success = total_success;
        this.total_fail = total_fail;
        this.errorMessage = error_message;
        this.statues = status;
        if (this.statues == '1') {
          if (this.total_fail == '0') {
            this.totalFail = true
            this.importWas = false
            this.importFailed = false
          } else {
            this.totalFail = false
            this.importWas = true
            this.importFailed = false
            this.getSummaryList(this.summaryFormInline)
          }
        } else if (this.statues == '2') {
          this.totalFail = false
          this.importWas = false
          this.importFailed = true
        }
        this.resultsDialogVisible = true
      },
      // 导入结果明细汇总列表
      getSummaryList(parameter) {
        this.loading = true
        importLogsDetailList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.resultslistData = res.content.rows
              // 分页赋值
              this.resultsPageparm.currentPage = this.summaryFormInline.page
              this.resultsPageparm.pageSize = this.summaryFormInline.rows
              this.resultsPageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      resultscallFather(parm) {
        this.summaryFormInline.page = parm.currentPage
        this.summaryFormInline.rows = parm.pageSize
        this.getSummaryList(this.summaryFormInline)
      },
      uploadFile(file) {
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.product_name == cell.innerText || row.sale_name == cell.innerText || row.product_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .keywordTextarea .el-textarea__inner {
    height: 120px;
    width: 500px;
    resize: none;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .groundingForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 500px;
  }

  /deep/ .groundingForm .el-input--small {
    width: 500px;
  }

  .userRole {
    width: 100%;
  }

  .price_icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .productImg {
    width: 120px;
    height: 120px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-right: 3px;
  }

  .avatar-uploader {
    height: 122px;
  }

  /deep/ .list_pic_url label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .giftForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 380px;
  }

  /deep/ .giftForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .giftForm .el-select-dropdown__item {
    width: 380px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .giftForm .el-input--small {
    width: 380px;
  }

  .sellerList {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 500px;
  }

  .prompt {
    font-size: 16px;
    color: #ec808d;
  }

  /deep/ .list_pic_url .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .importtion {
    text-align: center;
    padding: 0 20px 20px;
    font-size: 20px;
  }

  .color409EFF {
    color: #409EFF;
  }

  .colorec808d {
    color: #ec808d;
  }

  .colord9001b {
    color: #d9001b;
  }

  .textCenter {
    text-align: center;
  }

  .icon-container {
    position: relative;
    display: inline-block;
  }

  .icon-container i {
    font-size: 24px;
    position: relative;
  }

  .icon-container i::after {
    content: "上传excel文件";
    width: 100%;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    line-height: 12px;
  }

  .importLog {
    font-size: 16px;
    color: #555555;
    font-weight: 700;
    margin: 10px 0;
  }

  .avatar-uploaders .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploaders .el-upload:hover {
    border-color: #409EFF;
  }

  .zipFile {
    display: flex;
    align-items: center;
    margin-left: 20%;
  }

  .resultent {
    font-size: 20px;
    color: #d9001b;
    margin: 0 0 50px;
  }

</style>





// WEBPACK FOOTER //
// src/views/goods/Goods.vue